import { j as i } from "./jsx-runtime-3tyXYecC.mjs";
import { c as F } from "./index-DkZ16bcJ.mjs";
import { f as v } from "./index-LyFokDcn.mjs";
import { I as z } from "./icon-v2-DGtVEk7e.mjs";
import * as w from "react";
import y, { forwardRef as D } from "react";
import { m as N } from "./tss-DN0acMKN.mjs";
import { M as _, d as B } from "./constants-CnFYFetN.mjs";
import { g as E, c as U } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { m as L } from "./memoTheme-BzXKG_-k.mjs";
import { c as T } from "./createSvgIcon-ButWPptu.mjs";
import { g as Z } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { u as q } from "./useSlot-CRj3SG25.mjs";
import { s as C, u as H, c as O } from "./DefaultPropsProvider-CFfEbxdP.mjs";
const Q = T(/* @__PURE__ */ i.jsx("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");
function G(e) {
  return E("MuiAvatar", e);
}
Z("MuiAvatar", ["root", "colorDefault", "circular", "rounded", "square", "img", "fallback"]);
const V = (e) => {
  const {
    classes: r,
    variant: a,
    colorDefault: t
  } = e;
  return O({
    root: ["root", a, t && "colorDefault"],
    img: ["img"],
    fallback: ["fallback"]
  }, G, r);
}, W = C("div", {
  name: "MuiAvatar",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: a
    } = e;
    return [r.root, r[a.variant], a.colorDefault && r.colorDefault];
  }
})(L(({
  theme: e
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: 40,
  height: 40,
  fontFamily: e.typography.fontFamily,
  fontSize: e.typography.pxToRem(20),
  lineHeight: 1,
  borderRadius: "50%",
  overflow: "hidden",
  userSelect: "none",
  variants: [{
    props: {
      variant: "rounded"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius
    }
  }, {
    props: {
      variant: "square"
    },
    style: {
      borderRadius: 0
    }
  }, {
    props: {
      colorDefault: !0
    },
    style: {
      color: (e.vars || e).palette.background.default,
      ...e.vars ? {
        backgroundColor: e.vars.palette.Avatar.defaultBg
      } : {
        backgroundColor: e.palette.grey[400],
        ...e.applyStyles("dark", {
          backgroundColor: e.palette.grey[600]
        })
      }
    }
  }]
}))), J = C("img", {
  name: "MuiAvatar",
  slot: "Img",
  overridesResolver: (e, r) => r.img
})({
  width: "100%",
  height: "100%",
  textAlign: "center",
  // Handle non-square image.
  objectFit: "cover",
  // Hide alt text.
  color: "transparent",
  // Hide the image broken icon, only works on Chrome.
  textIndent: 1e4
}), K = C(Q, {
  name: "MuiAvatar",
  slot: "Fallback",
  overridesResolver: (e, r) => r.fallback
})({
  width: "75%",
  height: "75%"
});
function X({
  crossOrigin: e,
  referrerPolicy: r,
  src: a,
  srcSet: t
}) {
  const [o, s] = w.useState(!1);
  return w.useEffect(() => {
    if (!a && !t)
      return;
    s(!1);
    let l = !0;
    const n = new Image();
    return n.onload = () => {
      l && s("loaded");
    }, n.onerror = () => {
      l && s("error");
    }, n.crossOrigin = e, n.referrerPolicy = r, n.src = a, t && (n.srcset = t), () => {
      l = !1;
    };
  }, [e, r, a, t]), o;
}
const Y = /* @__PURE__ */ w.forwardRef(function(r, a) {
  const t = H({
    props: r,
    name: "MuiAvatar"
  }), {
    alt: o,
    children: s,
    className: l,
    component: n = "div",
    slots: p = {},
    slotProps: f = {},
    imgProps: g,
    sizes: x,
    src: u,
    srcSet: h,
    variant: S = "circular",
    ...I
  } = t;
  let d = null;
  const j = X({
    ...g,
    src: u,
    srcSet: h
  }), A = u || h, k = A && j !== "error", m = {
    ...t,
    colorDefault: !k,
    component: n,
    variant: S
  };
  delete m.ownerState;
  const b = V(m), [M, P] = q("img", {
    className: b.img,
    elementType: J,
    externalForwardedProps: {
      slots: p,
      slotProps: {
        img: {
          ...g,
          ...f.img
        }
      }
    },
    additionalProps: {
      alt: o,
      src: u,
      srcSet: h,
      sizes: x
    },
    ownerState: m
  });
  return k ? d = /* @__PURE__ */ i.jsx(M, {
    ...P
  }) : s || s === 0 ? d = s : A && o ? d = o[0] : d = /* @__PURE__ */ i.jsx(K, {
    ownerState: m,
    className: b.fallback
  }), /* @__PURE__ */ i.jsx(W, {
    as: n,
    className: U(b.root, l),
    ref: a,
    ...I,
    ownerState: m,
    children: d
  });
}), R = (e) => y.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 32 32", width: "32", height: "32" }, e),
  y.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    y.createElement("path", { fillRule: "nonzero", d: "M16,0 C7.164,0 0,7.164 0,16 C0,24.836 7.164,32 16,32 C24.836,32 32,24.836 32,16 C32,7.164 24.836,0 16,0 Z M16,6.22222222 C19.4305185,6.22222222 22.2222222,9.01392593 22.2222222,12.4444444 C22.2222222,15.874963 19.4305185,18.6666667 16,18.6666667 C12.5694815,18.6666667 9.77777778,15.874963 9.77777778,12.4444444 C9.77777778,9.01392593 12.5694815,6.22222222 16,6.22222222 Z M16,29.3333333 C12.56,29.3333333 9.43066667,28.0133333 7.06266667,25.8653333 C8.19066667,23.2546667 11.7546667,21.3333333 16,21.3333333 C20.2453333,21.3333333 23.8093333,23.2546667 24.9373333,25.8653333 C22.5693333,28.0133333 19.44,29.3333333 16,29.3333333 Z" })
  )
);
R.displayName = "PersonCircle32x32";
const ee = (e) => {
  switch (e) {
    case 24:
      return 12;
    case 32:
      return 20;
    case 40:
      return 24;
    case 48:
      return 30;
    case 56:
      return 32;
    case 64:
      return 36;
    case 72:
      return 40;
    case 80:
      return 48;
    case 96:
      return 60;
    case 128:
      return 90;
    case 160:
      return 120;
    case 224:
      return 170;
    default:
      return 20;
  }
}, c = {
  "xxx-small": "4px",
  "xx-small": "8px",
  "x-small": "12px",
  small: "16px",
  medium: "20px",
  large: "24px"
}, re = (e) => {
  switch (e) {
    case 24:
      return c["xxx-small"];
    case 32:
    case 40:
      return c["xx-small"];
    case 48:
    case 56:
      return c["x-small"];
    case 64:
    case 72:
    case 80:
      return c.small;
    case 96:
    case 128:
    case 160:
      return c.medium;
    case 224:
      return c.large;
    default:
      return c["xx-small"];
  }
}, ae = (e) => {
  switch (e) {
    case 32:
    case 40:
    case 48:
    case 56:
      return "1px 1px 0px 1px rgba(56, 49, 47, 0.04)";
    case 64:
    case 72:
    case 80:
    case 96:
    case 128:
      return "1px 1px 0px 2px rgba(56, 49, 47, 0.03)";
    case 160:
    case 224:
      return "2px 2px 0px 2px rgba(56, 49, 47, 0.05)";
    default:
      return "1px 1px 0px 1px rgba(56, 49, 47, 0.04)";
  }
}, te = N()((e) => {
  var s;
  const { constructs: r, palette: a, typography: t, mode: o } = e;
  return {
    root: {
      fontSize: (s = t.medium) == null ? void 0 : s.fontSize,
      outline: o === _.Dye ? `1px solid ${B.main}` : void 0
    },
    background: {
      backgroundColor: v.ifFeature("encore", r.icon.neutral.strong, a.gray[500])
    },
    // @startCleanup encore
    fallback: {
      backgroundColor: a.common.white,
      fill: a.gray[500],
      height: "100%",
      width: "100%"
    }
    // @endCleanup encore
  };
}), ve = D((e, r) => {
  const { classes: a } = te(void 0, { props: { classes: e.classes } }), { alt: t, children: o, className: s, size: l = 32, sx: n, src: p, srcSet: f, ...g } = e, x = t || (window.jQuery ? $.__("Avatar") : "Avatar"), u = !!(p || f);
  return /* @__PURE__ */ i.jsx(
    Y,
    {
      className: F(a.root, !u && a.background, s),
      imgProps: {
        alt: t || (window.jQuery ? $.__("Avatar") : "Avatar")
      },
      ref: r,
      src: p,
      srcSet: f,
      sx: {
        borderRadius: v.ifFeature("encore", re(l)),
        boxShadow: v.ifFeature("encore", ae(l)),
        height: l,
        width: l,
        ...n
      },
      ...g,
      "data-fabric-component": "Avatar",
      children: v.ifFeature(
        "encore",
        o || /* @__PURE__ */ i.jsx(z, { "aria-label": x, color: "neutral-inverted", name: "user-solid", size: ee(l) }),
        o || /* @__PURE__ */ i.jsx(R, { "aria-label": x, className: a.fallback, role: "img" })
      )
    }
  );
});
export {
  ve as A,
  R as I,
  Y as a
};
//# sourceMappingURL=avatar-1JHdkfls.mjs.map
